import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const ImportTypeProviderSchema = z.object({
	wsPrefixComplocProviderXrefId: z.number().nullable().optional(),
	compLocId: z.number(),
	providerId: z.number(),
	importTypeId: z.number(),
	prefix: z.string(),
	program: z.string(),
	brandName: z.string().nullable().optional(),
	providerName: z.string().nullable().optional(),
});

export type ImportTypeProvider = z.infer<typeof ImportTypeProviderSchema>;

export type SelectOption = {
	value: number;
	label: string;
};

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	importTypeId: number,
	params: object,
): Promise<{ data: ImportTypeProvider[]; total: number }> => {
	let queryString = '';
	if (params) {
		const paramsAsString = JSON.stringify(params)
			.replace(/:/g, '=')
			.replace(/,/g, '&')
			.replace(/[{}"]/g, '');

		const searchParams = new URLSearchParams(paramsAsString);
		if (pagination) {
			searchParams.append('pageSize', pagination.pageSize.toString());
			searchParams.append('pageIndex', pagination.pageIndex.toString());
		}

		if (sorting.length > 0) {
			searchParams.append('sortBy', sorting[0].id);
			searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
		}

		queryString = `?${searchParams.toString()}`;
	}

	const response = await fetch(`/admin/provider/${importTypeId}${queryString}`);

	return await response.json();
};

export const add = async (provider: ImportTypeProvider): Promise<boolean> => {
	const res = await fetch(`/admin/provider`, {
		method: 'POST',
		body: JSON.stringify(provider),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const update = async (
	provider: ImportTypeProvider,
): Promise<boolean> => {
	const res = await fetch(`/admin/provider`, {
		method: 'PATCH',
		body: JSON.stringify(provider),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const getProviderOptions = async (
	importTypeId: number,
	compLocId: number,
	selected?: number,
): Promise<SelectOption[]> => {
	const params = selected ? `?selected=${selected}` : '';
	const response = await fetch(
		`/admin/provider/${importTypeId}/options/${compLocId}${params}`,
	);
	return await response.json();
};
